export function TestimonialCard(props) {
    return (
        <div
            className="group rounded-xl p-6 bg-white/0 backdrop-blur-md shadow-md hover:bg-white hover:shadow-xl transition-all duration-300 ease-in-out flex flex-col border h-full"
            style={{ borderColor: "#DBF5FF" }}
        >
            <p className="text-sm text-gray-700 font-body leading-relaxed flex-1">
                {props.testimonial}
            </p>

            <div
                className="flex items-center justify-between mt-6 pt-6 border-t"
                style={{ borderColor: "#CACED0" }}
            >
                <div className="flex flex-col gap-1">
                    <h2 className="text-base font-display text-title font-semibold leading-none">
                        {props.name}
                    </h2>
                    <span className="text-xs leading-none text-muted">
                        {props.title}
                    </span>
                </div>
                <img
                    src={props.avatar}
                    alt={props.name}
                    className="size-12 rounded-full object-cover"
                />
            </div>
        </div>
    );
}
